import { useState } from "react";
import AppLayout from "../Layout";
import HeaderButtons from "../components/header_buttons";
import ItemHolder from "./item_holder";
import { useUI } from "../UIContext";
import { FormattedMessage } from "react-intl";

export default function AcceptSign({
  updating,
  setView,
  updateContactSignature,
}: {
  updating: boolean;
  setView: any;
  updateContactSignature: any;
}) {
  const { language } = useUI();
  const [signature, setSignature] = useState<string>("");

  function HeaderBottom() {
    if (updating) {
      return (
        <div className="flex flex-row items-center justify-end border-b-2 border-black bg-white px-4 py-2 w-full h-[50px] pointer-events-auto">
          <div className="font-bold">
            <FormattedMessage id="Updating..." />
          </div>
        </div>
      );
    }
    return (
      <div className="flex flex-row items-center border-b-2 border-black bg-white px-4 py-2 w-full">
        <div className="grow">
          <button
            className="bg-ppi-red text-white font-bold border-2 border-black rounded-md h-8 px-2"
            onClick={() => setView("decline")}
          >
            <FormattedMessage id="Decline" />
          </button>
        </div>
        <div>
          <button
            className={`${
              !!signature ? "bg-ppi-green" : "bg-gray-400"
            } text-white font-bold border-2 border-black rounded-md h-8 px-2`}
            disabled={!signature}
            onClick={updateContactSignature}
          >
            <FormattedMessage id="Allow" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <AppLayout
      header={
        <>
          <div className="font-bold text-xl text-center">
            <FormattedMessage id="Lien Release" />
          </div>
          <div className="flex flex-row justify-items-end px-1 translate-y-[2px] absolute">
            <button
              className="bg-ppi-blue text-white font-bold border-2 border-black rounded-md h-8 px-2"
              onClick={() => setView("release")}
            >
              <FormattedMessage id="Back" />
            </button>
          </div>
          <HeaderButtons />
        </>
      }
      header_bottom={<HeaderBottom />}
    >
      <div className="px-4 pt-[50px]">
        <div className="flex flex-col gap-2">
          <ItemHolder label="To all whom it may concern">
            <div>
              <FormattedMessage id="Allow PPI Mobile to use your electronic signature?" />
            </div>
          </ItemHolder>
          <ItemHolder>
            <input
              className="w-full"
              onBlur={() => {
                const the_zoom = (document?.body?.style as any)?.zoom;
                if (the_zoom) {
                  (document.body.style as any).zoom = "100%";
                  // document.body.style.transform = 'scale(1)';
                }
              }}
              onChange={(e: any) => setSignature(e.target.value)}
              placeholder={
                language === "es"
                  ? "Escriba su nombre aquí en lugar de su firma"
                  : "Type name here in place of your signature"
              }
              value={signature}
            />
          </ItemHolder>
        </div>
      </div>
    </AppLayout>
  );
}
